import { NavLink as RouterNavLink, useLocation } from 'react-router';
import { NavLink, Stack, Text } from '@mantine/core';
import { navigation, parseAllowedSections, filterNavigation } from '../lib/sections';
import { useAuth } from '../lib/auth';

export default function Sidebar() {
  const { admin } = useAuth();
  const { pathname } = useLocation();
  const allowed = parseAllowedSections(admin?.allowedSections ?? null);
  const filteredNav = filterNavigation(navigation, allowed);

  return (
    <Stack gap="md">
      {filteredNav.map((section) => (
        <Stack key={section.id} gap="xs">
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            {section.title}
          </Text>
          {section.children.map((item) => (
            <NavLink
              key={item.id}
              component={RouterNavLink}
              to={item.path}
              label={item.title}
              active={pathname === item.path || pathname.startsWith(item.path + '/')}
            />
          ))}
        </Stack>
      ))}
    </Stack>
  );
}
